var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 324,
    viewBox: "0 0 324 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.233 323.463C251.297 323.463 323.497 251.263 323.497 162.2C323.497 73.1367 251.297 0.936676 162.233 0.936676C73.1701 0.936676 0.970001 73.1367 0.970001 162.2C0.970001 251.263 73.1701 323.463 162.233 323.463Z",
    fill: "url(#paint0_linear_74_106)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_74_106",
    x1: 323,
    y1: 162,
    x2: 0.970005,
    y2: 162.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CFCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935264,
    stopColor: "#FF5A4D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.f1fc9e0b1f36ac4db4b95e77059c65ea.svg";
export { ForwardRef as ReactComponent };